module.exports = __webpack_public_path__ + "img/GDLCLogo2019-01.2dec20fb.svg";